import { fetchApi } from './api';
import type { AbsencesResponse, DaysResponse, HoursListResponse, HoursScope, VacationPlanResponse } from '../types/timerocket';

/**
 * TimeRocket Hours — read-only client for the four read endpoints.
 *
 * `fetchApi` unwraps the `{success,data}` envelope and throws an Error carrying the server's
 * message. For these endpoints a 403 is NOT a bug but an answer meant for the user ("The team
 * view is not enabled yet."), so callers display `err.message` rather than a generic text.
 */
export const timerocketApi = {
    list(params: { from: string; to: string; scope: HoursScope }): Promise<HoursListResponse> {
        const qs = new URLSearchParams({ from: params.from, to: params.to, scope: params.scope });
        return fetchApi<HoursListResponse>(`/timerocket/hours?${qs.toString()}`);
    },

    days(params: { employeeId: string; from: string; to: string }): Promise<DaysResponse> {
        const qs = new URLSearchParams({ employeeId: params.employeeId, from: params.from, to: params.to });
        return fetchApi<DaysResponse>(`/timerocket/hours/days?${qs.toString()}`);
    },

    /** Same period and scope semantics as `list`; the fine groups arrive as null outside own/CanEdit. */
    absences(params: { from: string; to: string; scope: HoursScope }): Promise<AbsencesResponse> {
        const qs = new URLSearchParams({ from: params.from, to: params.to, scope: params.scope });
        return fetchApi<AbsencesResponse>(`/timerocket/absences?${qs.toString()}`);
    },

    /** No period: the server answers "today to year end" and says so in the response. */
    vacationPlan(params: { scope: HoursScope }): Promise<VacationPlanResponse> {
        const qs = new URLSearchParams({ scope: params.scope });
        return fetchApi<VacationPlanResponse>(`/timerocket/vacation-plan?${qs.toString()}`);
    },
};
